/**
 * 云服务类别 产品图表页 图表Item
 *
 * @format
 */

import React, { useRef, useImperativeHandle, forwardRef } from 'react'
import BaseChart, { BaseChartMethod } from 'src/components/BaseChart'
import { _$ } from '@king-design/react'
import { handleUnit, tooltipFormatter } from 'src/utils'
interface MonitorChartItemAppProps {
  xData: any[]
  series: any[]
  maxValue: number
  minValue: number
  interval: string
  units: string
  title?: string
}
export interface MonitorChartItemAppHandle {
  chartResize: () => void
}
const MonitorChartItemApp = forwardRef<MonitorChartItemAppHandle, MonitorChartItemAppProps>(
  ({ xData, series, interval, units }, ref) => {
    const chartRef = useRef<BaseChartMethod>()
    useImperativeHandle(ref, () => ({
      chartResize: () => chartRef?.current.chartResize()
    }))

    return (
      <BaseChart
        ref={chartRef}
        options={{
          xAxis: {
            type: 'category',
            boundaryGap: false,
            data: xData
          },
          series: series,
          yAxis: {
            name: interval ? `${_$('周期')}:${interval}s` : '',
            type: 'value',
            axisLine: {
              show: true
            },
            splitNumber: 4,
            axisLabel: {
              margin: 5,
              formatter: function (value) {
                if (value === 0) {
                  return 0
                }
                const val = handleUnit(value, units, true)
                return val
              }
            }
            // max: function (value) {
            //   return value.max
            // }
          },
          tooltip: {
            trigger: 'axis',
            enterable: true,
            position: function (point, params, dom, rect, size) {
              const { contentSize, viewSize } = size
              let x, y
              // x
              if (point[0] > viewSize[0] - contentSize[0]) {
                x = point[0] - contentSize[0]
              } else {
                x = point[0]
              }
              // y
              if (point[1] > viewSize[1] - contentSize[1]) {
                y = point[1] - contentSize[1]
              } else {
                y = point[1]
              }
              x = x < 0 ? 0 : x
              return [x, y]
            },
            formatter: function (params) {
              return tooltipFormatter(params, units)
            }
          },
          legend: {
            right: '10px',
            top: 0,
            type: 'scroll',
            width: '70%'
          }
        }}
      />
    )
  }
)
export default React.memo(MonitorChartItemApp)
